import { type LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export interface Feature {
  icon: LucideIcon;
  text: string;
}

/** Simple icon-chip feature list for non-pinned beats (all items shown). */
export function FeatureList({ features, className }: { features: Feature[]; className?: string }) {
  return (
    <ul className={cn("space-y-3", className)}>
      {features.map((f) => {
        const Icon = f.icon;
        return (
          <li key={f.text} className="flex items-center gap-3">
            <span className="grid size-9 shrink-0 place-items-center rounded-xl border border-primary/40 bg-primary/10 text-primary">
              <Icon className="size-4" />
            </span>
            <span className="text-base text-foreground">{f.text}</span>
          </li>
        );
      })}
    </ul>
  );
}
